import { call, fork, put, take } from 'redux-saga/effects';
import api from 'services';
import * as actionTypes from 'constants/ActionTypes';

/**
 * Get cargo assigners
 * */
function* getCargoGazetters(opts) {
    const response = yield call(api.getCargoGazetters, opts);

    if (!response) {
        yield put({
            type: actionTypes.GET_CARGO_GAZETTERS.FAILURE,
            errors: [{ field: 'Could not load cargo gazetters' }],
        });

        return;
    }

    if (response && (!response.errors || !response.errors.length)) {
        yield put({
            type: actionTypes.GET_CARGO_GAZETTERS.SUCCESS,
            data: response.data,
        });

        return response;
    }

    yield put({
        type: actionTypes.GET_CARGO_GAZETTERS.FAILURE,
        errors: response.errors,
    });
}

export function* watchGetCargoGazetters() {
    while (true) {
        const { opts } = yield take(actionTypes.GET_CARGO_GAZETTERS.REQUEST);
        yield fork(getCargoGazetters, opts);
    }
}

/**
 * Delete cargo gazetter
 * */
function* deleteCargoGazetter(item) {
    const response = yield call(api.deleteCargoGazetter, item);
    if (response && !response.errors.length) {
        yield put({
            type: actionTypes.DELETE_CARGO_GAZETTER.SUCCESS,
            item,
        });

        yield put({
            type: actionTypes.ADD_NOTIFICATION,
            notification: {
                title: 'Success',
                message: 'Deleted',
                level: 'success',
                autoDismiss: 2,
            },
        });

        return;
    }

    yield put({
        type: actionTypes.DELETE_CARGO_GAZETTER.FAILURE,
        item,
        error: response.errors,
    });

    yield put({
        type: actionTypes.ADD_NOTIFICATION,
        notification: {
            title: 'Error',
            message: response.errors[0].messages[0],
            level: 'error',
            _id: item._id,
            autoDismiss: 2,
        },
    });
}

export function* watchDeleteCargoGazetter() {
    while (true) {
        const { item } = yield take(actionTypes.DELETE_CARGO_GAZETTER.REQUEST);
        yield fork(deleteCargoGazetter, item);
    }
}

export default [
    watchGetCargoGazetters,
    watchDeleteCargoGazetter,
];



// WEBPACK FOOTER //
// ./app/sagas/cargoes/gazetters.js